import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import e, { useState as t, useRef as n, useEffect as s } from "react";
import { render as r } from "react-dom";

var i = {
  ids: [],
  add: function add(e, t) {
    this.ids.push({
      id: e,
      callback: t
    });
  },
  remove: function remove(e) {
    if (e) {
      var _this$ids$find = this.ids.find(function (t) {
        return t.id === e;
      }),
          _t = _this$ids$find.callback;

      _t(), this.ids = this.ids.filter(function (t) {
        return t.id !== e;
      });
    } else this.ids.forEach(function (e) {
      return e.callback();
    }), this.ids = [];
  }
},
    o = function o(_ref) {
  var t = _ref.message,
      n = _ref.onClose,
      _ref$type = _ref.type,
      s = _ref$type === void 0 ? "info" : _ref$type,
      _ref$width = _ref.width,
      r = _ref$width === void 0 ? "300px" : _ref$width,
      i = _ref.rtl,
      o = _ref.closeOnClick,
      a = _ref.onMouseEnter,
      c = _ref.onMouseLeave;
  return e.createElement("div", {
    className: "item ".concat(s, " ").concat(i ? "rtl" : "ltr"),
    style: {
      width: r
    },
    onClick: function onClick() {
      return o && n();
    },
    onMouseEnter: a,
    onMouseLeave: c
  }, e.createElement("span", null, t), e.createElement("button", {
    onClick: n
  }, "✖"));
},
    a = {};

var c = function c(e, t) {
  var _this = this;

  _classCallCheck(this, c);

  var n = -1,
      s = 0;
  this.remaining = t, this.pause = function () {
    clearTimeout(n), _this.remaining -= Date.now() - s;
  }, this.resume = function () {
    s = Date.now(), clearTimeout(n), n = setTimeout(e, _this.remaining);
  }, this.resume();
};

var l = function l(r) {
  var _t2 = t([]),
      _t3 = _slicedToArray(_t2, 2),
      l = _t3[1],
      _t4 = t(!1),
      _t5 = _slicedToArray(_t4, 2),
      m = _t5[0],
      u = _t5[1],
      _t6 = t(!1),
      _t7 = _slicedToArray(_t6, 2),
      d = _t7[0],
      p = _t7[1],
      h = n([]),
      _r$autoClose = r.autoClose,
      y = _r$autoClose === void 0 ? 3e3 : _r$autoClose,
      _r$delay = r.delay,
      g = _r$delay === void 0 ? 0 : _r$delay,
      f = r.id,
      _r$animation = r.animation,
      E = _r$animation === void 0 ? {} : _r$animation,
      v = E.duration || 300,
      b = y > 0 ? y : 0,
      $ = function $(e) {
    h.current = function (e, t) {
      return e.filter(function (e) {
        return e.key != t;
      });
    }(h.current, e), l(h.current), 0 === h.current.length && r.cleared();
  };

  return s(function () {
    var t = h.current.findIndex(function (e) {
      return e.key == f;
    }),
        n = h.current[t];
    if (!n) return;
    var s = a[f].remaining,
        r = m && !d ? {} : {
      animationName: "".concat(E.out),
      animationDelay: "".concat(s - v, "ms"),
      animationDuration: "".concat(v, "ms")
    },
        i = e.cloneElement(n, Object.assign({}, n.props, {
      style: r
    }));
    h.current.splice(t, 1, i), l(_toConsumableArray(h.current));
  }, [m, d]), s(function () {
    var t = {
      id: f,
      onClose: function onClose() {
        setTimeout(function () {
          return $(f);
        }, v), a[f].remaining = v, p(!0);
      },
      onMouseEnter: function onMouseEnter() {
        return n("pause");
      },
      onMouseLeave: function onMouseLeave() {
        return n("resume");
      }
    },
        n = function n(e) {
      r.pauseOnHover && a[f] && a[f][e](), u("pause" === e);
    };

    var s = r.render ? r.render(t) : e.createElement(o, Object.assign({}, r, t));
    v && (s = e.createElement("div", {
      key: f,
      style: {
        animationName: "".concat(E.in, ", ").concat(E.out),
        animationDelay: "0ms, ".concat(b, "ms"),
        animationDuration: "".concat(v, "ms, ").concat(v, "ms")
      }
    }, s));
    var m = r.onlyLast ? [] : h.current,
        _r$newestOnTop = r.newestOnTop,
        d = _r$newestOnTop === void 0 ? !0 : _r$newestOnTop;
    h.current = d ? [s].concat(_toConsumableArray(m)) : [].concat(_toConsumableArray(m), [s]), i.add(f, function () {
      return $(f);
    }), setTimeout(function () {
      return l(h.current);
    }, g), a[f] = new c(function () {
      return y && $(f);
    }, g + b + v);
  }, [r]), e.createElement(e.Fragment, null, h.current);
};

var m = "simple-react-notifier";
var u,
    d = 0;

var p = function p(t) {
  t = Object.assign({}, u || {}, t);
  var _t8 = t,
      _t8$position = _t8.position,
      n = _t8$position === void 0 ? "top-right" : _t8$position;
  var s = document.querySelector("." + m + "." + n);
  return s || ((s = document.createElement("div")).classList.add(m, n), s.style.direction = t.rtl ? "rtl" : "ltr", document.body.appendChild(s)), r(e.createElement(l, Object.assign({}, t, {
    id: d,
    cleared: function cleared() {
      try {
        document.body.removeChild(s);
      } catch (e) {}
    }
  })), s), ++d - 1;
};

p.info = function (e) {
  return p({
    message: e,
    type: "info"
  });
}, p.success = function (e) {
  return p({
    message: e,
    type: "success"
  });
}, p.error = function (e) {
  return p({
    message: e,
    type: "error"
  });
}, p.warn = function (e) {
  return p({
    message: e,
    type: "warn"
  });
}, p.configure = function (e) {
  u = e;
}, p.dismiss = function (e) {
  return i.remove(e);
};
export default p;